/**
 * We have a discrepancy between TypeScript and GraphQL.
 * Options in Typescript: Type or Undefined
 * Options in GraphQL: Type or null
 * Here we have to map from one to the other. Maybe we find a better way later.
 */

export function nullToUndefined<T>(
  mayBeNullValue: T | undefined | null,
): T | undefined {
  return mayBeNullValue === null ? undefined : mayBeNullValue;
}

export function undefinedToNull<T>(
  mayBeUndefinedValue: T | undefined | null,
): T | null {
  return mayBeUndefinedValue === undefined ? null : mayBeUndefinedValue;
}
